import { render, staticRenderFns } from "./activityForm.vue?vue&type=template&id=4547a60a&scoped=true&"
import script from "./activityForm.vue?vue&type=script&lang=js&"
export * from "./activityForm.vue?vue&type=script&lang=js&"
import style0 from "./activityForm.vue?vue&type=style&index=0&id=4547a60a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4547a60a",
  null
  
)

export default component.exports